import React, { useState } from "react";
import { Link } from "react-router-dom";
import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'
import QRCode from "react-qr-code";
import { useHistory } from "react-router-dom"
// import { CopyToClipboard } from 'react-copy-to-clipboard';
// import toast from 'react-hot-toast';
import SocialShare from './../social-share'
import "./style.css"


const Main = (props) => {
  const [showButtons, setShowButtons] = useState(true);
  const [codigo] = useState(props.codigo);
  const [open, setOpen] = useState(false)
  const history = useHistory()

  console.log(window.location.href)
 
  const buttons = [
    { icon: "fa-share-alt", text: "COMPARTILHAR A PÁGINA", action: "", type: 1, url: 'https://sigmobioficial.com/' },
    { icon: "fa-qrcode", text: "VISUALIZAR O QRCODE", action: "", type: 3 },
    { icon: "fa-qrcode", text: "BAIXAR O PANFLETO", action: "https://flyer.sigmobi.com", down: true, type: 2 },
  ];

  return (
    <div className="container">
      <div className="login-wrap">
        <div className="form-login">
          <div className="card">
            <div className="card-block wizard-content flex-content">
              <div className="vstack gap-3">
                <div className="p-2 w-100">
                  <img
                    src="https://cdn.sigmobi.com/lpimg/ic_banner_card_invict.png"
                    className="img-fluid banner_top rounded"
                    alt="banner sig"
                  />

                </div>

                <div className="p-2 w-100">
                  <p className="text-start roboto-medium">Meu código</p>
                  <p className="text-start roboto-medium">{props.codigo}</p>
                  <hr className="hr-custom" />
                </div>

                <div className="p-2 w-100">
                  <div className="d-grid gap-2 flex-center">
                    {showButtons && buttons.map((button, index) => {
                       return (
                          button.type == 3
                            ?
                            <button
                              onClick={() => setOpen(true)}
                              className="btn btn-primary-c"
                            >
                              <i className={`fa ${button.icon} mr-icon`}></i>
                              {button.text}
                            </button>

                            :
                            button.type == 1
                              ?
                              <>
                                {/* <CopyToClipboard text={button.action.concat(button.url).concat(props.codigo)}
                                  onCopy={() => {
                                    // share here
                                    // toast.success('Link copiado com sucesso!')                                }}>
                                  <button
                                    to={{ pathname: button.action.concat(button.url).concat(props.codigo) }}
                                    className="btn btn-primary-c"
                                  >
                                    <i className={`fa ${button.icon} mr-icon`}></i>
                                    {button.text}
                                  </button>
                                </CopyToClipboard> */}
                                <button
                                  className="btn btn-primary-c"
                                  onClick={(e) => {
                                    e.preventDefault()
                                    setShowButtons(false)
                                  }}
                                >
                                  <i className={`fa ${button.icon} mr-icon`}></i>
                                  {button.text}
                                </button>
                              </>
                              :
                              <a href={button.action.concat('/').concat(props.codigo).concat('/').concat(true)}
                                className="btn btn-primary-c flex-center"
                              >
                                <i className={`fa ${button.icon} mr-icon`}></i>
                                {button.text}
                              </a>
                        )
                    })}

                    {!showButtons && (
                      <SocialShare
                        setShowButtons={setShowButtons}
                        url={window.location.href}
                        text={'VENHA PARA A SIG MOBI!'}
                      />
                    )}
                  </div>
                </div>
              </div>
              {
                open &&
                <BottomSheet open={open}>
                  <div className="right">
                    <a onClick={() => setOpen(false)}>
                      <i className={`fa fa-times mr-icon`}></i>
                    </a>
                  </div>
                  <div className="center p-2">
                    <QRCode
                      size={64}
                      style={{ height: "auto", maxWidth: "20%", width: "20%" }}
                      value={'https://sigmobioficial.com/'.concat(props.codigo)}
                      viewBox={`0 0 256 256`}
                    />
                  </div>
                </BottomSheet>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
